import React, { useEffect, useState } from 'react';
import './notification-filter.scss';
import { TabsProps } from 'antd';
import { NotificationDto, NotificationType } from '../../../dtos/notification.dto';

interface NotificationFilterProps {
    data: NotificationDto[];
    setData: (filteredData: NotificationDto[]) => void;
}

const NotificationFilter: React.FC<NotificationFilterProps> = ({ data, setData }) => {

    const [filter, setFilter] = useState<NotificationType | 'All'>('All');

    useEffect(() => {
        filterNotifications(data, filter);
    }, [data, filter]);

    const handleFilterChange = (key: string) => {
        setFilter(key as NotificationType | 'All');
    };

    const filterNotifications = (dataToFilter: NotificationDto[], key: (NotificationType | 'All')) => {
        const filteredNotifications =
            key === 'All' ? dataToFilter : dataToFilter.filter((n) => n.type === key);
        setData(filteredNotifications);
    };

    const filters: TabsProps['items'] = [
        { key: 'All', label: 'All' },
        { key: NotificationType.POLICY_UPDATE, label: 'Policy' },
        { key: NotificationType.LOG_EXPORT, label: 'Logs' },
        { key: NotificationType.TIPS, label: 'Tips' },
    ];

    return (
        <div className={'notification-filter'}>
            {filters.map(_ => (
                <button type="button" className={`notification-filter-label-wrapper ${filter === _.key ? 'active' : ''}`}
                      onClick={() => handleFilterChange(_.key)} key={`notification-filter-${_.key}`}>
                    <span
                        className={`notification-filter-label ${filter === _.key ? 'active' : ''}`}>
                            {_.label}
                    </span>
                </button>))}
        </div>
    );
};

export default NotificationFilter;
